module.exports = __webpack_public_path__ + "images/arval13cf0066520a234f771b692b1ea23f4e.png";